import { Button, Layout, Menu } from 'antd';
import {
  ApiOutlined,
  BookOutlined,
  FileTextOutlined,
  LogoutOutlined,
  MessageOutlined,
  RobotOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import './main-menu.css';

const { Sider } = Layout;

const renderMenuLabel = (icon, label) => (
  <span className="main-menu-item-content">
    {icon}
    <span>{label}</span>
  </span>
);

const getSelectedMenuKey = (pathname) => {
  if (pathname.startsWith('/dialogs')) {
    return '/dialogs';
  }
  if (pathname.startsWith('/users')) {
    return '/users';
  }
  if (pathname.startsWith('/channels')) {
    return '/channels';
  }
  if (pathname.startsWith('/agents')) {
    return '/agents';
  }
  if (pathname.startsWith('/spaces')) {
    return '/spaces';
  }
  if (pathname.startsWith('/articles')) {
    return '/articles';
  }
  return null;
};

const MainMenu = ({ isAdmin, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedMenuKey = getSelectedMenuKey(location.pathname);
  const menuItems = [
    { key: '/dialogs', label: renderMenuLabel(<MessageOutlined />, 'Диалоги') },
    isAdmin ? { key: '/channels', label: renderMenuLabel(<ApiOutlined />, 'Каналы') } : null,
    isAdmin ? { key: '/agents', label: renderMenuLabel(<RobotOutlined />, 'Агенты') } : null,
    isAdmin ? { key: '/spaces', label: renderMenuLabel(<BookOutlined />, 'Пространства') } : null,
    isAdmin ? { key: '/articles', label: renderMenuLabel(<FileTextOutlined />, 'Статьи') } : null,
    isAdmin ? { key: '/users', label: renderMenuLabel(<TeamOutlined />, 'Пользователи') } : null,
  ].filter(Boolean);

  return (
    <Sider className="main-menu-sider" width={104} theme="dark">
      <button
        className="main-menu-brand"
        type="button"
        aria-label="Главная"
        title="Главная"
        onClick={() => navigate('/')}
      >
        <span className="main-menu-brand-mark" aria-hidden="true">
          <svg viewBox="0 0 32 32" fill="none">
            <path
              d="M9.2 13.4c0-3.8 3-6.9 6.8-6.9s6.8 3.1 6.8 6.9v6.2c0 1.3-1 2.3-2.3 2.3-1.2 0-2.2-1-2.2-2.3v-5.2c0-.6.5-1.1 1.1-1.1.5 0 1 .3 1.3.7.1-2.6-2-4.7-4.7-4.7s-4.8 2.1-4.7 4.7c.3-.4.8-.7 1.3-.7.6 0 1.1.5 1.1 1.1v5.2c0 1.3-1 2.3-2.2 2.3-1.3 0-2.3-1-2.3-2.3v-6.2z"
              fill="#99f6e4"
            />
            <circle cx="16" cy="24.4" r="1.7" fill="#5eead4" />
          </svg>
        </span>
      </button>
      <Menu
        className="main-menu"
        mode="vertical"
        theme="dark"
        selectedKeys={selectedMenuKey ? [selectedMenuKey] : []}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
      />
      <Button className="main-menu-logout-button" type="text" onClick={onLogout}>
        <span className="main-menu-item-content">
          <LogoutOutlined />
          <span>Выход</span>
        </span>
      </Button>
    </Sider>
  );
};

export default MainMenu;
